// extracted by mini-css-extract-plugin
export var option = "_58-1";
export var optionActive = "_58-2";
export var pill = "_58-0";